import { useMutation, useQueryClient } from '@tanstack/react-query'
import { hapticSuccess, hapticError } from '@/telegram'
import { toast } from 'sonner'
import { useClobClient } from './useClobClient'
import { placeSellOrder } from '@/lib/clobClient'

interface PlaceSellParams {
  tokenId: string
  /** Number of shares (outcome tokens) to sell */
  size: number
  price: number
  tickSize?: string
  negRisk?: boolean
}

export function usePlaceSell() {
  const queryClient = useQueryClient()
  const clobClient = useClobClient()

  return useMutation({
    mutationFn: async (params: PlaceSellParams) => {
      if (clobClient) {
        return placeSellOrder(clobClient, {
          tokenId: params.tokenId,
          size: params.size,
          price: params.price,
          tickSize: params.tickSize ?? '0.001',
          negRisk: params.negRisk ?? false,
        })
      }
      throw new Error('Connect a wallet to sell')
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['openOrders'] })
      void queryClient.invalidateQueries({ queryKey: ['positions'] })
      hapticSuccess()
      toast.success('Sell order placed')
    },
    onError: (err) => {
      hapticError()
      toast.error(err instanceof Error ? err.message : 'Error placing sell order')
    },
  })
}
